<div class="email-input-container">
  <label
    *ngIf="!useCustomLabel"
    [for]="id"
    class="email-label"
  >{{ label }}
    <span *ngIf="required" class="required-asterisk">*</span>
  </label>

  <input
    #inputEl
    [id]="id"
    type="email"
    [name]="name"
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [required]="required"
    (input)="onInputChange($event)"
    (blur)="markAsTouched()"
    class="email-input form-control"
    [class.invalid]="touched && !isValidEmail(value)"
  />

  <div class="error-messages" *ngIf="touched">
    <span *ngIf="required && !value" class="error">{{'common.personal-information.email-required-message' | translate | ucfirst }}</span>
    <span *ngIf="value && !isValidEmail(value)" class="error">{{'common.personal-information.email-invalid-message' | translate | ucfirst }}</span>
    <span *ngIf="value && isValidEmail(value) && hasDeliverabilityWarning(value)" class="warning">{{'common.personal-information.email-deliverability-warning' | translate | ucfirst }}</span>
  </div>
</div>
